import React from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import Icon from '../../Icons';

const ShiftAssigmentsCard = ({ cards, handleMoreInfoButton, showSpinner }) => {
  const todayShiftAssignments = cards?.shiftAssignmentsStartTodayCount || 0;

  return (
    <Card className="mb-1">
      <Col className="top-header-green">
        <Col className="card-header-title" style={{ fontSize: '12px' }}>
          ASIGNACIÓN DE TURNOS
        </Col>
      </Col>
      {showSpinner ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <Col className="div-content">
          <Row style={{ height: 140 }}>
            <Col sm={12} md={4} xs={12} className="mb-2 mt-2 circular-progress">
              <div style={{ width: 100, height: 100 }}>
                <CircularProgressbar
                  value={todayShiftAssignments}
                  text={`${todayShiftAssignments}`}
                  styles={buildStyles({
                    textSize: '26px',
                    pathColor: '#29B48F',
                    textColor: '#29B48F'
                  })}
                />
              </div>
            </Col>
            <Col sm={12} md={8} xs={12} className="mb-3 mt-4">
              <p className="text-dark-bold text-center">Asignacion(es) de turno para hoy</p>
            </Col>
          </Row>
          {
            <button
              type="button"
              onClick={handleMoreInfoButton}
              style={{
                border: '1px solid #65b68f',
                backgroundColor: '#65b68f',
                position: 'absolute',
                right: 20,
                bottom: 20
              }}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
      )}
    </Card>
  );
};

export default ShiftAssigmentsCard;
